import { UsersListPage } from './users-list/users-list'
import { AddUser } from './add-user/add-user'
import { InviteUser } from './invite-user/invite-user'

export const UsersManagmentStack = {
  UsersListPage,
  AddUser,
  InviteUser,
}
